import { Text, View } from 'react-native';
import styled from 'styled-components/native';

import {
  coral,
  neutralDark,
  neutralLight,
  warrior,
  white,
} from '../../constants/color';
import Image from '../../elements/Image';
import Touchable from '../../elements/Touchable';

export const S = {
  ModalWrapper: styled(View)`
    background-color: ${white};
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    padding: 14px 30px 10px 10px;
    justify-content: flex-end;
    align-items: center;
  `,
  LogoWrapper: styled(View)`
    position: absolute;
    left: 0;
    margin-top: 10px;
  `,
  LogoImage: styled(Image)`
    width: 70px;
    height: 70px;
  `,
  Content: styled(View)`
    padding-left: 80px;
  `,
  TextTitle: styled(Text)`
    color: ${warrior};
    font-size: 18px;
    font-weight: 600;
    margin-top: 16px;
    margin-bottom: 8px;
  `,
  TextHint: styled(Text)`
    color: ${warrior};
    font-size: 15px;
    font-weight: normal;
    margin-bottom: 20px;
  `,
  CloseBtn: styled(Touchable)`
    position: absolute;
    right: 2px;
    top: 2px;
    padding: 10px;
  `,
  ButtonGroup: styled(View)`
    height: 50px;
    border-top-width: 1px;
    border-top-color: ${neutralLight};
    flex-wrap: nowrap;
    width: 100%;
    flex-direction: row;
    justify-content: center;
  `,
  AllowBtnText: styled(Text)`
    font-size: 15px;
    text-align: center;
    line-height: 50px;
    color: ${white};
  `,
  AllowBtn: styled(Touchable)`
    background-color: ${coral};
    height: 50px;
    flex-grow: 1;
  `,
  CencelBtnText: styled(Text)`
    font-size: 15px;
    text-align: center;
    line-height: 50px;
    color: ${neutralDark};
  `,
  CancelBtn: styled(Touchable)`
    background-color: ${white};
    height: 50px;
    flex-grow: 1;
  `,
};
